module.exports = __webpack_public_path__ + "static/media/EmailInActive.0a89380b.svg";